<div class="tb" [class.tb--actual]="variant() === 'actual'" [dir]="languageService.direction()">
    <div class="tb__track">
        @if (fill(); as fill) {
            <span class="tb__fill" [style.--tb-from]="fill.from" [style.--tb-to]="fill.to"></span>
        }

        @for (marker of markers(); track $index) {
            <span class="tb__marker" [style.--tb-x]="marker.ratio"></span>
        }

        @for (label of labels(); track $index) {
            <span class="tb__label" [style.--tb-x]="label.ratio">{{ label.label }}</span>
        }
    </div>
</div>
